// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__vocm4","copyright":"Footer_copyright__wPAQz","inlineIcon":"Footer_inlineIcon__h3NMx"};